import { PERMISSIONS } from '../../../../../constants'
import {
  useRegisterManager,
  useRetailerSettingsManager,
  useUserPermission,
} from '../../../../../ng-compat/hooks'
import { isCrossLocationFulfilmentRolloutEnabled } from '../../../../../util/cross-location-fulfilment'

export const useCrossLocationFulfilmentGate = () => {
  const registerManager = useRegisterManager()
  const retailerSettingsManager = useRetailerSettingsManager()
  const hasPermission = useUserPermission(PERMISSIONS.SALE_CROSS_LOCATION)
  const isRolloutEnabled = isCrossLocationFulfilmentRolloutEnabled()
  const isAccountEnabled = retailerSettingsManager.isCrossLocationFulfilmentEnabled()
  const isSourceOutletEligible = registerManager.isSourceOutletCLFEnabled()

  return {
    canUseCrossLocationFulfilment:
      isRolloutEnabled &&
      isAccountEnabled &&
      hasPermission &&
      isSourceOutletEligible,
    isRolloutEnabled,
    isAccountEnabled,
    hasPermission,
    isSourceOutletEligible,
  }
}
